import { MetricName } from "../metric-types";
import { TimedPerformanceMetric } from "./timed-performance-metric";

export const mapLoadingPerformance = new TimedPerformanceMetric(MetricName.MAP_LOADING, 2);

export const mapboxLoadingPerformance = new TimedPerformanceMetric(MetricName.MAPBOX_LOADING, 1);
